import React from 'react';
import {useSelector} from 'react-redux';
import Questionnaire1Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/homes/hot-flashes-treatment/Questionnaire10Screen';
import {RootState} from '~/redux/root-reducer';
import {HOT_FLASHES_TREATMENT_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const HotFlashesTreatment = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case HOT_FLASHES_TREATMENT_KEYS.START:
        trackPageViewGA('/hot-flashes-treatment/start', 'MDQ-Hot Flashes Treatment - Start');
        return <Questionnaire1Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.PROFILE:
        trackPageViewGA('/hot-flashes-treatment/profile', 'MDQ-Hot Flashes Treatment - Profile');
        return <Questionnaire2Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.INVALID:
        trackPageViewGA('/hot-flashes-treatment/invalid', 'MDQ-Hot Flashes Treatment - Invalid');
        return <Questionnaire3Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.SELECT_SYMPTOMS:
        trackPageViewGA('/hot-flashes-treatment/select-symptoms', 'MDQ-Hot Flashes Treatment - Select Symptoms');
        return <Questionnaire4Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.DESCRIBE_CURRENT_SYMPTOMS:
        trackPageViewGA(
          '/hot-flashes-treatment/describe-current-symptoms',
          'MDQ-Hot Flashes Treatment - Describe Current Symptoms',
        );
        return <Questionnaire5Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.HAVING_REGULAR_PERIODS:
        trackPageViewGA(
          '/hot-flashes-treatment/having-regular-periods',
          'MDQ-Hot Flashes Treatment - Having Regular Periods',
        );
        return <Questionnaire6Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING:
        trackPageViewGA(
          '/hot-flashes-treatment/current-or-history-of-any-of-following',
          'MDQ-Hot Flashes Treatment - Current Or History Of Any Of Following',
        );
        return <Questionnaire7Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS:
        trackPageViewGA(
          '/hot-flashes-treatment/up-to-date-pap-smears-cervical-screenings',
          'MDQ-Hot Flashes Treatment - Up To Date Pap Smears Cervical Screenings',
        );
        return <Questionnaire8Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.UP_TO_DATE_BREAST_SCREENINGS:
        trackPageViewGA(
          '/hot-flashes-treatment/up-to-date-breast-screenings',
          'MDQ-Hot Flashes Treatment - Up To Date Breast Screenings',
        );
        return <Questionnaire9Screen />;
      case HOT_FLASHES_TREATMENT_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/hot-flashes-treatment/other-condition-or-medical-history',
          'MDQ-Hot Flashes Treatment - Other Condition Or Medical History',
        );
        return <Questionnaire10Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default HotFlashesTreatment;
